export const PRICING_SECTION = {
  id: "group-access",
  tierLabel: "База",
  title: "Базовая подписка",
  subtitle:
    "Групповой доступ по числу сотрудников. Включено 10 ГБ для видео и материалов проектов — этого достаточно для старта.",
  trialNote:
    "После регистрации — 14 дней триала тарифа «Микрокоманда» с полным доступом к публикации и команде.",
  plans: [
    {
      packageId: "biz_s_15",
      tierName: "Старт",
      title: "Микрокоманда",
      price: 100,
      pricePeriod: "/ 3 дн.",
      badge: "Групповой доступ",
      perUnit: "До 15 сотрудников",
      segmentLabel: "1–15 чел.",
      features: [
        "3 дня подписки",
        "10 ГБ видео на компанию",
        "Ссылка для всей команды",
        "Telegram и MAX",
      ],
      highlight: false,
    },
    {
      packageId: "biz_m_50",
      tierName: "Бизнес",
      title: "Отдел",
      price: 9990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "16–50 сотрудников",
      segmentLabel: "16–50 чел.",
      features: [
        "30 дней подписки",
        "10 ГБ видео на компанию",
        "Несколько сценариев",
        "Telegram и MAX",
      ],
      highlight: true,
    },
    {
      packageId: "biz_l_100",
      tierName: "Pro",
      title: "Компания",
      price: 14990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "51–100 сотрудников",
      segmentLabel: "51–100 чел.",
      features: [
        "30 дней подписки",
        "10 ГБ видео на компанию",
        "Программы по подразделениям",
        "Telegram и MAX",
      ],
      highlight: false,
    },
  ],
};

export const PRICING_TIER_COMPARISON = {
  title: "Что входит в тариф",
  subtitle: "Сравнение уровней — выберите масштаб команды.",
  columns: [
    { id: "biz_s_15", label: "Старт", packageId: "biz_s_15" },
    { id: "biz_m_50", label: "Бизнес", packageId: "biz_m_50", highlight: true },
    { id: "biz_l_100", label: "Pro", packageId: "biz_l_100" },
  ],
  rows: [
    { label: "Сотрудников", values: ["до 15", "до 50", "до 100"] },
    { label: "База знаний", values: ["check", "check", "check"] },
    { label: "Тренажёр", values: ["check", "check", "check"] },
    { label: "Сценарии с видео", values: ["Без лимита", "Без лимита", "Без лимита"] },
    { label: "Telegram и MAX", values: ["check", "check", "check"] },
    { label: "Место для видео", values: ["10 ГБ", "10 ГБ", "10 ГБ"] },
    { label: "Аналитика", values: ["Базовая", "Расширенная", "Расширенная"] },
    { label: "Админы команды", values: ["1", "до 3", "Без лимита"] },
  ],
};

export const MEDIA_STORAGE_SECTION = {
  id: "media-storage",
  tierLabel: "Дополнительно",
  title: "Дополнительное место для видео",
  subtitle:
    "Если 10 ГБ базового объёма не хватает, подключите медиа-пакет. Оплата помесячная — как у подписки, без автосписания.",
  plans: [
    {
      packageId: "media_10",
      title: "+10 ГБ",
      price: 790,
      pricePeriod: "/ мес",
      perUnit: "Дополнительно к базовым 10 ГБ",
      highlight: false,
    },
    {
      packageId: "media_50",
      title: "+50 ГБ",
      price: 2490,
      pricePeriod: "/ мес",
      perUnit: "Выгоднее за гигабайт",
      highlight: true,
    },
    {
      packageId: "media_200",
      title: "+200 ГБ",
      price: 7990,
      pricePeriod: "/ мес",
      perUnit: "Для больших библиотек",
      highlight: false,
    },
  ],
};

export const PRICING_FAQ = [
  {
    question: "Есть ли пробный период?",
    answer:
      "Да. После регистрации автоматически активируется триал тарифа «Микрокоманда» на 14 дней — можно публиковать проекты и открывать доступ команде до 15 сотрудников. По окончании триала оформите платную подписку в разделе «Тарифы».",
  },
  {
    question: "Как сотрудники получают доступ?",
    answer:
      "Вы оформляете подписку по размеру команды, публикуете проект и делитесь ссылкой в Telegram или MAX. Сотрудники переходят по ссылке и проходят программу без персональных ключей.",
  },
  {
    question: "Сколько сотрудников может пройти сценарий?",
    answer:
      "Лимит зависит от тарифа: до 15, до 50 или до 100 человек.",
  },
  {
    question: "Сколько места включено для видео?",
    answer:
      "На каждую компанию включено 10 ГБ для видеофайлов всех проектов. Если нужно больше — подключите медиа-пакет: оплата помесячная, без автосписания, продлевается вручную в разделе «Тарифы».",
  },
  {
    question: "Что будет при превышении лимита?",
    answer:
      "Загрузка новых видео будет недоступна, пока вы не освободите место или не докупите медиа-пакет. Уже опубликованные материалы и прохождение для команды продолжают работать.",
  },
  {
    question: "Можно ли запустить обучение без подписки?",
    answer:
      "Редактор доступен для подготовки материалов. Для публикации и группового доступа по ссылке нужна активная подписка или триал — он включается автоматически на 14 дней после регистрации.",
  },
  {
    question: "Как продлевается подписка?",
    answer:
      "Автоматического списания с карты нет. За 5 дней и за 1 день до окончания периода мы напомним по email — продлите подписку в разделе «Тарифы». Если оплата не поступит вовремя, групповой доступ к сценариям будет приостановлен.",
  },
];
